import { render, staticRenderFns } from "./OshaCitationList.vue?vue&type=template&id=4a08bf96"
import script from "./OshaCitationList.vue?vue&type=script&lang=js"
export * from "./OshaCitationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports